
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 12 12","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.4 7.875c0-2.89-2.104-5.276-4.8-5.588V1H5.4v1.287C2.704 2.599.6 4.984.6 7.875v1.25h10.8v-1.25zM0 9.75h12V11H0V9.75z"}})])
          )
        }
      }
    